import { Coordinate } from "ol/coordinate";
import SYMBOL_DATA from "./symbolData";

const URN_TOKENS = [
    "S=112", // klasicka urna
    "S=113", // neidentifikovany hrob
    "S=114"  // projektovana urna
];

export default function generateSymbol(point:Coordinate, symbolToken:string, angleToken:string, scaleToken:string):Coordinate[][] {
    let symbolType = +symbolToken.substr(2);

    let angle = (angleToken) ? +angleToken.substr(2): 0;
    let scale = (scaleToken) ? +scaleToken.substr(2): 1;

    if (SYMBOL_DATA[symbolType] && SYMBOL_DATA[symbolType].length > 0) {
        let lookup = SYMBOL_DATA[symbolType].map(l1 => l1.map(c1 => transformPoint(c1, point, scale, -100+angle))); // uhly vo VTX su v rozsahu 0-400 pricom 400 je 360stupnov
        return lookup.filter(l => l.length > 1);
    }
    return undefined;
}

function transformPoint(point: Coordinate, translation: Coordinate, scale: number, angle: number):Coordinate {
    let result = []; 
    let angleRad = Math.PI * angle / 200.0;
    result[0] = point[1]*Math.cos(angleRad) - point[0]*Math.sin(angleRad);// v projekcii mam prehodene suradnice, preto vymienam aj zdrojove suradnice
    result[1] = point[1]*Math.sin(angleRad) + point[0]*Math.cos(angleRad);
    result[0] *= scale * 0.1; // 10x zmensenie odmerane porovnanim velkosti symbolov s hrobmi na vykreslenej mape
    result[1] *= scale * 0.1;
    result[0] += translation[0];
    result[1] += translation[1];
    return result;
}